import React from "react";

const SidebarSkeleton = () => {
  return (
    <aside id="sidebar" className="sidebar-skeleton-wrapper">
      <div className="sidebar-skeleton-logo sidebar-skeleton-shimmer" />
      <ul className="sidebar-skeleton-list">
        {Array?.from({ length: 5 }).map((_, i) => (
          <li
            key={i}
            className="sidebar-skeleton-item sidebar-skeleton-shimmer"
          />
        ))}
      </ul>
    </aside>
  );
};

export default SidebarSkeleton;
